import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UiTranslateModule } from '@fcom/ui-translate';
import { DirectiveModule } from '@fcom/common/directives/directive.module';

import { IconsModule } from '../icons/icons.module';
import { ButtonComponent } from './button/button.component';
import { CtaButtonComponent } from './cta-button/cta-button.component';
import { LoaderModule } from '../loader/loader.module';
import { IconButtonComponent } from './icon-button/icon-button.component';

@NgModule({
  declarations: [ButtonComponent, CtaButtonComponent, IconButtonComponent],
  imports: [CommonModule, UiTranslateModule, IconsModule, LoaderModule, DirectiveModule],
  exports: [ButtonComponent, CtaButtonComponent, IconButtonComponent],
  providers: [],
})
export class ButtonModule {}
